export default __webpack_public_path__ + "static/media/star3.54cb40da.gif";